import { Component } from '@angular/core';


@Component({
  selector: 'valg-dk-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: [ 'privacy-policy.component.scss' ]
})
export class PrivacyPolicyComponent {

}